import request from '@/utils/request'

// 登录
export const login = data => {
  return request({
    url: '/admin/login',
    method: 'POST',
    data
  })
}

// // 获取用户信息
export const getUserInfo = () => {
  return Promise.resolve({
    username: 'admin',
    role: 'admin'
  })
}
